export default function ({ store, route }) {
  store.commit('SET_RETURN_URL', route.fullPath)
}
